import { Skeleton } from '@mui/material'
import React from 'react'

const IconLoading = () => {
    return (
        <>
            {Array(20).fill(20).map((_, index) => (
                <div className='col-2 rounded text-center' key={index}>
                    <Skeleton variant="rounded" height={100} />
                </div>
            ))}
        </>
    )
}

export default IconLoading